import { Switch } from "@trackman/web-shared-components";
import { MarkerType } from "../enums";
import { useStores } from "index";
import { observer } from "mobx-react-lite";

interface IChangeMarkers {
  onChange: (selectedTypes: MarkerType[]) => void;
}

const ChangeMarkers = observer(({ onChange }: IChangeMarkers) => {
  const { systemStore: ss } = useStores();

  const handleChangingMarkerType = (value: MarkerType) => {
    ss.setIsLoading(true);
    setTimeout(() => {
      const newSelectedTypes = ss.selectedTypes.includes(value)
        ? ss.selectedTypes.filter((t) => t !== value)
        : [...ss.selectedTypes, value];
      onChange(newSelectedTypes);
      ss.setSelectedTypes(newSelectedTypes);
      ss.setIsLoading(false);
    }, 100);
  };

  return (
    <div
      className="p-3 bg-light-blur rounded position-absolute top-0 right-0 m-3 d-flex align-items-center justify-content-center gap-2 flex-column"
      style={{
        width: "132px",
        height: "96px",
      }}
    >
      {ss.isLoading ? (
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <>
          <MarkerTypeComponent
            type={MarkerType.BASEBALL}
            isSelected={ss.selectedTypes.includes(MarkerType.BASEBALL)}
            disabled={ss.isLoading}
            onChange={() => handleChangingMarkerType(MarkerType.BASEBALL)}
          />
          <MarkerTypeComponent
            type={MarkerType.SOFTBALL}
            isSelected={ss.selectedTypes.includes(MarkerType.SOFTBALL)}
            disabled={ss.isLoading}
            onChange={() => handleChangingMarkerType(MarkerType.SOFTBALL)}
          />
        </>
      )}
    </div>
  );
});

const MarkerTypeComponent = ({
  type,
  isSelected,
  disabled,
  onChange,
}: {
  type: MarkerType;
  isSelected: boolean;
  disabled: boolean;
  onChange: () => void;
}) => {
  return (
    <Switch
      label={type}
      checked={isSelected}
      name={type}
      disabled={disabled}
      onChange={onChange}
    />
  );
};

export default ChangeMarkers;
